/**
 * RAKNIDA · assets/rk-exhibitions-timeline.js
 * Upgrade Exhibitions / Awards panels to prototype year + entry lists.
 *
 * Sources (first match wins):
 *  1. <script data-rk-ex-json> — JSON [{y|year, e|entry|text}]
 *  2. Existing ul.rk-*-ex-list (Liquid already rendered)
 *  3. Parse [data-rk-ex-source] HTML / text for year-prefixed lines
 */
(function () {
  'use strict';

  var YEAR_LINE = /^(\d{4})\s*[—–\-|:·•,]?\s+(.+)$/;
  var YEAR_ONLY = /^(\d{4})$/;

  function parseJson(el) {
    if (!el) return null;
    try {
      var raw = (el.textContent || '').trim();
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!Array.isArray(data)) return null;
      return data
        .map(function (row) {
          if (!row || typeof row !== 'object') return null;
          var y = String(row.y || row.year || row.Y || '').trim();
          var e = String(
            row.e || row.entry || row.text || row.title || row.exhibition || ''
          ).trim();
          var loc = String(row.l || row.loc || row.location || row.venue || '').trim();
          if (!/^\d{4}$/.test(y) || !e) return null;
          return { y: y, e: e, l: loc };
        })
        .filter(Boolean);
    } catch (err) {
      return null;
    }
  }

  function pushYearLine(items, text) {
    var line = String(text || '')
      .replace(/\u00a0/g, ' ')
      .replace(/^[\s•·\-*]+/, '')
      .trim();
    if (!line) return;
    var loc = '';
    /* Structured: "2024 | Exhibition title | Location" or "2024 — Title | Location" */
    var pipe = line.split('|').map(function (p) {
      return p.trim();
    });
    if (pipe.length >= 3 && /^\d{4}$/.test(pipe[0])) {
      items.push({ y: pipe[0], e: pipe[1], l: pipe[2] });
      return;
    }
    if (pipe.length === 2) {
      loc = pipe[1];
      line = pipe[0];
    }
    var m = line.match(YEAR_LINE);
    if (m) {
      items.push({ y: m[1], e: m[2].trim(), l: loc });
      return;
    }
    /* "2025 Event without separator" */
    m = line.match(/^(\d{4})\s+(.+)$/);
    if (m) {
      items.push({ y: m[1], e: m[2].trim(), l: loc });
      return;
    }
    /* Trailing year: "... Fair & Fest, House of Glamour, 2022" */
    m = line.match(/^(.+?)[,\s—–\-]+(\d{4})\s*$/);
    if (m && m[1] && m[2]) {
      items.push({
        y: m[2],
        e: m[1].replace(/^[\s\-–—]+|[\s\-–—]+$/g, '').trim(),
        l: loc
      });
      return;
    }
    /* Year in any dash-separated segment: "Exhibitor - Title - 2016 - Venue" */
    var parts = line.split(/\s*[—–\-]\s*/);
    if (parts.length >= 3) {
      for (var i = 0; i < parts.length; i++) {
        var seg = parts[i].trim();
        if (!YEAR_ONLY.test(seg)) continue;
        var yr = parseInt(seg, 10);
        if (yr < 1900 || yr > 2099) continue;
        var entryParts = [];
        for (var j = 0; j < parts.length; j++) {
          if (j !== i) entryParts.push(parts[j].trim());
        }
        var entry = entryParts.join(' — ').replace(/\s+/g, ' ').trim();
        if (entry) {
          items.push({ y: seg, e: entry, l: loc });
          return;
        }
      }
    }
  }

  function collectLines(sourceEl) {
    if (!sourceEl) return [];
    var clone = sourceEl.cloneNode(true);
    clone.querySelectorAll('br').forEach(function (br) {
      br.replaceWith(document.createTextNode('\n'));
    });
    var lines = [];
    function addText(raw) {
      String(raw || '')
        .replace(/\r/g, '')
        .split(/\n+/)
        .forEach(function (line) {
          line = line.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
          if (line) lines.push(line);
        });
    }
    var blocks = clone.querySelectorAll('p, li');
    if (blocks.length) {
      Array.prototype.forEach.call(blocks, function (node) {
        addText(node.textContent);
      });
    } else {
      addText(clone.textContent);
    }
    return lines;
  }

  function parseSource(sourceEl) {
    if (!sourceEl) return [];
    var items = [];
    collectLines(sourceEl).forEach(function (line) {
      pushYearLine(items, line);
    });
    /* Deduplicate */
    var seen = {};
    return items.filter(function (it) {
      var key = it.y + '|' + it.e;
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function readExistingList(mount, ns) {
    var ul = mount.querySelector('ul.rk-' + ns + '-ex-list');
    if (!ul) return [];
    var items = [];
    ul.querySelectorAll('li').forEach(function (li) {
      var y = (li.querySelector('.rk-' + ns + '-ex-list__y') || {}).textContent || '';
      var eEl = li.querySelector('.rk-' + ns + '-ex-list__e');
      var lEl = li.querySelector('.rk-' + ns + '-ex-list__l');
      var loc = ((lEl && lEl.textContent) || '').trim();
      var e = '';
      if (eEl) {
        var clone = eEl.cloneNode(true);
        var locClone = clone.querySelector('.rk-' + ns + '-ex-list__l');
        if (locClone) locClone.remove();
        e = (clone.textContent || '').trim();
      }
      y = y.trim();
      if (/^\d{4}$/.test(y) && e) items.push({ y: y, e: e, l: loc });
    });
    return items;
  }

  function renderList(ns, items) {
    var ul = document.createElement('ul');
    ul.className = 'rk-' + ns + '-ex-list';
    items.forEach(function (it) {
      var li = document.createElement('li');
      var ys = document.createElement('span');
      ys.className = 'rk-' + ns + '-ex-list__y';
      ys.textContent = it.y;
      var es = document.createElement('span');
      es.className = 'rk-' + ns + '-ex-list__e';
      es.appendChild(document.createTextNode(it.e || ''));
      if (it.l) {
        var ls = document.createElement('span');
        ls.className = 'rk-' + ns + '-ex-list__l';
        ls.textContent = it.l;
        es.appendChild(ls);
      }
      li.appendChild(ys);
      li.appendChild(es);
      ul.appendChild(li);
    });
    return ul;
  }

  function ensureCollapseChrome(root, ns, itemCount) {
    var collapse = root.querySelector('[data-rk-ex-collapse]');
    if (!collapse) return;
    var long = itemCount > 5;
    var fitClass = 'rk-' + ns + '-collapse--fit';
    var fadeClass = 'rk-' + ns + '-fade';
    var moreClass = 'rk-' + ns + '-see-more';
    var moreAttr = 'data-rk-' + ns + '-more';

    if (long) {
      collapse.classList.remove('is-on', fitClass);
      if (!collapse.querySelector('[data-rk-ex-fade], .' + fadeClass)) {
        var fade = document.createElement('span');
        fade.className = fadeClass;
        fade.setAttribute('data-rk-ex-fade', '');
        fade.setAttribute('aria-hidden', 'true');
        collapse.appendChild(fade);
      }
      if (!root.querySelector('[data-rk-ex-more], [' + moreAttr + ']')) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = moreClass;
        btn.setAttribute(moreAttr, '');
        btn.setAttribute('data-rk-ex-more', '');
        btn.setAttribute('data-more', 'See more ↓');
        btn.setAttribute('data-less', 'Show less ↑');
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = 'See more ↓';
        root.appendChild(btn);
      }
    } else {
      collapse.classList.add('is-on', fitClass);
      var fadeEl = collapse.querySelector('[data-rk-ex-fade], .' + fadeClass);
      if (fadeEl) fadeEl.remove();
      var moreEl = root.querySelector('[data-rk-ex-more], [' + moreAttr + ']');
      if (moreEl) moreEl.remove();
    }
  }

  function enhance(root) {
    var ns = root.getAttribute('data-rk-ex-ns') || 'oe';
    var mount = root.querySelector('[data-rk-ex-mount]');
    if (!mount) return;

    var fromSource = parseSource(root.querySelector('[data-rk-ex-source]'));
    var fromJson = parseJson(root.querySelector('[data-rk-ex-json]')) || [];
    var fromList = readExistingList(mount, ns);
    var items = fromSource;
    if (!items.length) items = fromJson;
    if (!items.length) items = fromList;
    if (fromSource.length > items.length) items = fromSource;
    if (fromJson.length > items.length) items = fromJson;
    if (!items.length) {
      /* Last resort: parse visible fallback RTE */
      items = parseSource(mount);
    }
    if (!items.length) return;

    mount.innerHTML = '';
    mount.appendChild(renderList(ns, items));
    root.setAttribute('data-rk-ex-count', String(items.length));
    ensureCollapseChrome(root, ns, items.length);
  }

  function boot() {
    document.querySelectorAll('[data-rk-ex-timeline]').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
